module.exports = "<div class=\"card w-full\">\n  <h5 class=\"mb-32\" *ngIf=\"cardTitle\">{{cardTitle}}</h5>\n  <ng-content></ng-content>\n</div>\n"